import {type ValidationError} from "../../infrastructure/types";

export interface ConfigurationResponseDto {
  id: number;
  name: string;
  description: string;
  typeGroupPairs: TypeGroupPair[];
  lastUpdate: string;
}

export interface ConfigurationRequestDto {
  name: string;
  description: string;
  typeGroupPairs: TypeGroupPair[];
}

export interface Configuration extends TypeGroups {
  id: number;
  name: string;
  description: string;
  typeGroupPairs: TypeGroupPair[];
  lastUpdate: string;
  file: FileList;
}

export type TypeGroups = Record<`type_${number}_group_${number}`, boolean>;

export interface TypeGroupPair {
  typeId: number;
  groupId: number;
}

export type UserType = Value;

export type UserGroup = Value;

export interface Value {
  code: number;
  description: string;
  parents?: Value[];
}

export interface ValueDto {
  v: number;
  d: string;
}

export type UserTypeDto = ValueDto;

export interface UserGroupDto extends ValueDto {
  children?: UserGroupDto[];
}

export interface WithDescription {
  description: string;
}

export interface ConfigurationError {
  message: string;
  validationErrors: ConfigurationValidationErrors;
}

export interface ConfigurationValidationErrors {
  name?: ValidationError[];
  description?: ValidationError[];
  file?: ValidationError[];
  typeGroupPairs?: Array<ValidationError<ConfigurationValidationTypeGroupParameters>>;
}

export interface ConfigurationValidationTypeGroupParameters {
  typeId: number;
  groupId: number;
}

export enum ConfigurationFieldName {
  name = "name",
  description = "description",
  file = "file",
  typeGroupPairs = "typeGroupPairs"
}
